const COLLECTION_PREFIX_PATTERN = /-col-c\d+$/

export const isCollectionPageUrl = (pageUrl) =>
  typeof pageUrl === 'string' && COLLECTION_PREFIX_PATTERN.test(pageUrl)

const _pathOf = (url) => {
  if (!url) return ''
  const match = url.match(/^https?:\/\/[^/]+(\/.*)$/)
  if (match) return match[1]
  return url.startsWith('/') ? url : `/${url}`
}

export const prefixCollectionUrl = (productUrl, collectionPageUrl) => {
  if (!productUrl || !isCollectionPageUrl(collectionPageUrl)) return productUrl
  const productPath = _pathOf(productUrl)
  const origin = productUrl.match(/^https?:\/\/[^/]+/)?.[0] ?? ''
  return `${origin}/${collectionPageUrl}${productPath}`
}

const PDP_COLLECTION_PREFIX_PATTERN = /^\/([^/]*-col-c\d+)\/[^/]+-pdp-p\d+-c\d+/

export const extractCollectionPrefix = (path) => {
  if (!path) return null
  const match = path.match(PDP_COLLECTION_PREFIX_PATTERN)
  return match ? match[1] : null
}
